module.exports = __webpack_public_path__ + "img/minus.0daeb846.svg";